import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import {
  BoxSeam,
  CurrencyRupee,
  Building,
  Globe2,
} from "react-bootstrap-icons";

import "../css/Section6.css";

const Section6 = () => {
  return (
    <section className="about-nimbus-section">
      <Container>
        <Row>
          {/* LEFT CONTENT */}
          <Col lg={4}>
            <span className="section-label">About Nimbus</span>

            <p className="about-text">
              As a Group, Nimbus Adcom started its journey from 2010 as a
              boot-strap organisation however inception of Nimbus BPO Limited
              has been done in 2018.
            </p>

            <p className="about-text">
              In past few years we have managed different service portfolios for
              Contact Center Services, Bulk SMS Services, IT-Digital Marketing
              Solutions, Cloud Telephony, Business Consultancies, Hiring-
              Placement agency and Real Estate services.
            </p>

            <p className="about-text">
              Till date, we have served various Corporates, Unicorns, Retail
              Customers and Government Organisations. Support of our other
              sister concern companies make Nimbus BPO robust and competent
              into market.
            </p>

            <div className="about-btns">
              <Button variant="outline-secondary" className="me-3">
                Learn More
              </Button>
              <Button variant="primary">Contact Us</Button>
            </div>
          </Col>

          {/* RIGHT CONTENT */}
          <Col lg={8}>
            <Row className="g-4">
              <Col md={6}>
                <Card className="feature-card">
                  <Card.Body>
                    <div className="icon-box">
                      <BoxSeam />
                    </div>
                    <h5>Flexibility</h5>
                    <p>
                      Every business experiences periods of increased demand or
                      encounters a slowdown, we are fully prepared to adapt and
                      cater to the specific needs.
                    </p>
                    <p>
                      We are flexible enough for smooth ramp up & ramp down as
                      per the demand.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="feature-card">
                  <Card.Body>
                    <div className="icon-box">
                      <CurrencyRupee />
                    </div>
                    <h5>Domain Expertise</h5>
                    <p>
                      With our diverse team of industry experts, we boast domain
                      expertise across every sector.
                    </p>
                    <p>
                      From E-commerce to healthcare, finance to education.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="feature-card">
                  <Card.Body>
                    <div className="icon-box">
                      <Building />
                    </div>
                    <h5>Thinking Partner</h5>
                    <p>
                      Our dedication to providing you with valuable information
                      and analysis day in and day out empowers your organisation
                      to make informed decisions.
                    </p>
                    <p>
                      We deliver business insights to continuously fine-tune
                      your processes.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="feature-card">
                  <Card.Body>
                    <div className="icon-box">
                      <Globe2 />
                    </div>
                    <h5>PAN India Presence</h5>
                    <p>
                      We have planned our branches in such a manner so that we
                      would be able to offer most of the required languages.
                    </p>
                    <p>
                      Tier-1, Tier-2 & Tier-3 cities with WFH or split shift
                      models.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Section6;
